import {inject, injectable, IServiceConfig, RestService} from "@athena-portal/core";
import {Observable, of} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {AjaxError, AjaxResponse} from "rxjs/ajax";
import {ICoverCheckerPortalService} from "../ICoverCheckerPortalService";
import {Types} from "../../Types";

@injectable()
export class CoverCheckerPortalServiceImpl extends RestService implements ICoverCheckerPortalService {

    private configuration: IServiceConfig;

    constructor(@inject(Types.CoverCheckerPortalServiceConfig) configuration: IServiceConfig) {
        super();
        this.configuration = configuration;
    }

    public getCoverDetailsByVin(registrationNumber: string): Observable<any> {
        const productId: number = 2;

        return this.doRequest(
            `/cover-checker/getCarDriveAwayCoverInfo?registrationNumber=${registrationNumber}&productId=${productId}`,
            "GET"
        )
    }

    private doRequest(urlAppend: string, method?: string): Observable<any> {
        return super.getProtectedResource({
            body: "",
            method: method ?? "GET",
            headers: {
                ...this.configuration.customHeaders
            },
            url: `${this.configuration.serviceBaseUrl}${urlAppend}`,
        }, this.configuration.customQueryStringParameters).pipe(
            map((response: AjaxResponse): any => {
                    return response.response;
                }
            ), catchError((err: AjaxError): any => {
                return of(err);
            })
        );
    }
}
